<template>
    <div class=" d-flex flex-column">
		<div
			v-if="!hideClose"
			class="mb-3 align-self-end"
		>
			<BaseButton
				:filled="true"
				border="round"
				color="black"
				@click="$emit('close')"
				aria-label="Close">
				<IconClose />
			</BaseButton>
		</div>
		<div class="aup-base-photo-details__img-container d-flex">
			<div class="aup-base-photo-details__photo mx-auto">
				<img  :style="{
					width: photoWidth
				}"
					:src="resolveMediaImageURL(imageURL, imageZestyGuid, 500)"
					:srcset="imageSrcset"
					:alt="alt || ''"
					sizes="100vw"
					@error="onRespImageError($event, 500)"
				/>
			</div>
		</div>

        <div class="aup-base-photo-details__background-wrapper"></div>

        <div class="">
			<!-- ROW 1: Likes, Share, Report -->
            <div
                class="aup-base-photo-details__row row no-gutters bg-black"
            >
                <div
                    class="col-8 offset-lg-1 col-lg-8 d-flex justify-content-start pl-4 pl-lg-0"
                >
                    <div class="d-flex align-items-center pr-4" v-if="showLikes">
						<BaseLikeButton
							:isSelf="isSelfProfile"
							:likedContent="imageGUID"
							:isLiked="isLiked"
							:likeCount="photoLikes"
							:likeType="'media'"
							textPlacement="right"
							:showCount="true"
							:loggedIn="loggedIn"
							:profileView="!communityGalleryView"
							:showCountOnHover="false"
							:height="32"
							:width="32"
						/>
                    </div>

                    <div class="d-flex align-items-center" v-if="verifiedSonyPhoto">
                        <IconAlphaVerify alt="Sony Icon" class="aup-base-photo-card__svg-badge" />
                        <p class="d-inline-block mb-0 ml-2 text-white">Verified Sony Photo</p>
                    </div>
                </div>
                <div class="col-4 col-lg-2 d-flex justify-content-center justify-content-lg-end align-items-center">
                    <a
						v-if="!isSelfProfile && loggedIn"
                        role="button"
                        href="#"
                        class="text-white mb-0 t-micro t-micro--regular"
                        @click="openReportModal"
                    >Report</a>
                </div>
            </div>

            <!-- ROW 2: Photo Title  -->
            <div class="row no-gutters bg-white border border-bottom" v-if="photoTitle">
                <div class="col-10 offset-lg-1 col-lg-9 d-flex align-content-center">
                    <div class="py-2 py-lg-4 pl-4 pl-lg-0">
                        <h4 class="t-heavy m-0">error:call:14</h4>
						<p class="mt-2">error:call:15</p>
                    </div>
                </div>
                <div class="col-2 d-flex align-content-center justify-content-end">

                </div>
            </div>

            <!-- ROW 3: USER DATA AND BADGE -->
            <div class="row no-gutters bg-white border border-bottom">
                <div class="col-auto offset-lg-1 pl-4 pl-lg-0 py-2 py-lg-4 pr-4">
                    <div class="d-flex align-items-center" v-if="!communityGalleryView">
                        <figure class="mb-0 aup-base-photo-card__avatar-wrapper aup-base-photo-card__avatar-wrapper--large">
                            <img
                                class="aup-base-photo-card__avatar border border-white rounded-circle"
								:src="profilePhotoSrc"
                                :alt="`Profile photo of ${name}`"
                                @error="onRespImageError($event, 100)"
                            />
                        </figure>
                        <div
                            class="aup-base-photo-details__username col d-flex py-2 py-lg-4 pr-5 align-items-md-center align-items-start flex-column"
                        >
                            <p class="t-heavy m-0">error:call:16</p>
                            
                            <div class="d-flex flex-column d-md-none justify-content-center ml-0 mb-1" v-if="location">
                                <p class="t-micro text-uppercase text-muted m-0">Location</p>
                                <p class="m-0">error:call:17</p>
                            </div>
                            <div class="d-flex flex-column d-md-none justify-content-center" v-if="dateTaken">
                                <p class="t-micro text-uppercase text-muted m-0" >Date</p>
                                <p class="m-0">error:call:18</p>
                            </div>
                        </div>
                    </div>
                    <a :href="profileLink" class="aup-base-photo-card__profile-link" v-if="communityGalleryView">
                        <figure class="mb-0 aup-base-photo-card__avatar-wrapper aup-base-photo-card__avatar-wrapper--large">
                            <img
								:src="renderedProfilePhoto || this.calcRespImageURL(profilePhotoZestyGuid, 100)"
                                class="aup-base-photo-card__avatar"
                                v-if="renderedProfilePhoto || profilePhotoZestyGuid"
								:alt="`Profile photo of ${name}`"
                                @error="onRespImageError($event, 100)"
                            />
                        </figure>
                        <p
                            class="t-micro t-shadow text-uppercase m-0 ml-2 aup-base-photo-card__profile-link-text aup-base-photo-card__profile-link-text--dark"
                            v-if="name"
                        >error:call:19</p>
                    </a>
                </div>
                <div
                    class="aup-base-photo-details__location-date col-12 col-md-6 border-left d-flex align-content-center justify-content-start"
					v-if="location || dateTaken"
                >
                    <div class="d-none d-md-flex flex-column justify-content-center ml-4" v-if="location">
                        <p class="t-micro text-uppercase text-muted m-0">Location</p>
                        <p class="m-0">error:call:20</p>
                    </div>
                    <div class="d-none d-md-flex flex-column justify-content-center ml-4" v-if="dateTaken">
                        <p class="t-micro text-uppercase text-muted m-0" >Date</p>
                        <p class="m-0">error:call:21</p>
                    </div>
                </div>
            </div>

            <!-- ROW 4: EXIF DATA -->
            <div class="row no-gutters bg-white border border-bottom" v-if="verifiedSonyPhoto">
                <div class="col-12 offset-lg-1 col-lg-10 d-flex flex-wrap py-2 py-lg-4 pl-4 pl-lg-0" >
                    <div class="aup-base-photo-details__exifdata d-flex flex-column">
                        <p
                            class="t-micro text-uppercase text-muted m-0"
                            v-if="cameraMake || cameraModel"
                        >camera</p>
						<component :is="cameraLink ? 'a' : 'span'" :href="cameraLink" target="_blank"><p class="m-0">error:call:22 error:call:23</p></component>
                    </div>
                    <div
                        class="aup-base-photo-details__exifdata d-flex flex-column"
                        v-if="lensModel"
                    >
                        <p class="t-micro text-uppercase text-muted m-0">Lens</p>
						<component  :is="lensLink ? 'a' : 'span'"  :href="lensLink" target="_blank"><p class="m-0">error:call:24</p></component>
                    </div>
                    <div
                        class="aup-base-photo-details__exifdata d-flex flex-column"
                        v-if="isFocalLength(focalLength)"
                    >
                        <p class="t-micro text-uppercase text-muted m-0">focal length</p>
                        <p class="m-0">error:call:25</p>
                    </div>
                    <div class="d-flex flex-column aup-base-photo-details__exifdata" v-if="isAperture(fStop)">
                        <p class="t-micro text-uppercase text-muted m-0">
                            aperture
                        </p>
                        <p class="m-0">error:call:26</p>
                    </div>
                    <div
                        class="aup-base-photo-details__exifdata d-flex flex-column"
                        v-if="isExposure(exposure)"
                    >
                        <p class="t-micro text-uppercase text-muted m-0">exposure</p>
                        <p class="m-0">error:call:27</p>
                    </div>
                    <div class="aup-base-photo-details__exifdata d-flex flex-column" v-if="isIso(ISO)">
                        <p class="t-micro text-uppercase text-muted m-0">iso</p>
                        <p class="m-0">error:call:28</p>
                    </div>
                </div>
            </div>

            <!-- ROW 5: Tags -->
            <div class="row no-gutters bg-white border border-bottom col-auto offset-lg-1 pl-4 pl-lg-0 py-2" v-if="categoryTags">
                <div class="col-12 offset-lg-1 col-lg-10 d-flex align-content-center py-2 py-lg-4 flex-wrap">
                    <BaseTextLabel
                        v-for="(tag, index) in splitCategoryTags(categoryTags)"
                        :key="index"
                        :text="tag"
                    />
                </div>
            </div>
        </div>
        <!-- REPORT MODAL  -->
        <BaseReportModal
            :showReportModal="showReportModal"
            :reportReasonsList="reportReasonsList"
            v-on:close="showReportModal = false"
            :userName="name"
            @onClose="showReportModal = false"
            :reportTypePhoto="true"
			:reportItemGuid="reportItemGuid"
        />
    </div>
</template>

<script>
import BaseTextLabel from '@/components/global/BaseTextLabel';
import BaseReportModal from '@/components/global/BaseReportModal';
import BaseButton from '@/components/global/BaseButton';
import BaseLikeButton from '@/components/global/BaseLikeButton';
import { parseDateMixin, calcRespImageURLMixin } from '@/mixins/mixins.js';
import { API_GET_LEAN_PROFILE } from '@/api-service.js';
import DYNAMICS_ENTITIES from "@/PROFILE_CONSTANTS/DYNAMICS_ENTITIES";
import { PROFILE_CONSTANTS } from "@/PROFILE_CONSTANTS";
import Exif from "@/Exif";

export default {
	name: 'BasePhotoDetails',
	mixins: [ parseDateMixin, calcRespImageURLMixin ],
    components: {
        BaseTextLabel,
        BaseReportModal,
        BaseButton,
        BaseLikeButton
    },
    data() {
        return {
            profilePhotoZestyGuid: '',
            baseProfileURL: PROFILE_CONSTANTS.PROFILE_URL,
            profileLink: '',
            loggedIn: false,
            reportReasonsList: DYNAMICS_ENTITIES.REPORTING_REASONS,
            showReportModal: false
        };
    },
    mounted: async function() {
        if ($cookies.isKey('au_guid') && $cookies.isKey('au_profile_guid')) {
            this.loggedIn = true;
        }

        if(this.communityGalleryView) {
            const userData = await API_GET_LEAN_PROFILE(this.profileUrl);

			const profileURL = userData.data.profile.ppd_profileurl;
			this.profileLink = (profileURL.startsWith("http://") || profileURL.startsWith("https://"))
				? profileURL
				: this.baseProfileURL + profileURL + '/';

            if (userData.data.images) {
                userData.data.images.forEach(item => {
                    if (item.ppd_isprofile) {
                        this.profilePhotoZestyGuid = item.ppd_zestyguid;
                    }
                });

            }
        }
    },
    props: {
        // derived by the API (photo alt text with fallbacks)
        alt: {
            type: String,
            default: ''
        },
        photoTitle: {
            type: String,
            default: ''
        },
		photoDescription: {
			type: String,
			default: ''
		},
        name: {
            type: String,
            default: ''
        },
        profileUrl: {
            type: String,
            default: ''
        },
        renderedProfilePhoto: {
            type: String,
            default: ''
        },
        communityGalleryView: {
            type: Boolean,
            default: false
        },
        dateTaken: {
            type: String,
            default: ''
        },
        location: {
            type: String,
            default: ''
        },
        cameraModel: {
            type: String,
            default: ''
        },
        cameraMake: {
            type: String,
            default: ''
        },
        lensModel: {
            type: String,
            default: null
        },
        staffPick: {
            type: Boolean,
            default: false
        },
        imageZestyGuid: {
            type: String,
            default: null
        },
        imageURL: {
            type: String,
            default: null
        },
        focalLength: {
            type: String,
            default: ''
        },
        fStop: {
            type: String,
            default: ''
        },
        exposure: {
            type: String,
            default: ''
        },
        ISO: {
            type: String,
            default: ''
        },
        categoryTags: {
            type: String,
            default: ''
        },
        photoShares: {
            type: Number,
            default: 0
        },
        photoLikes: {
            type: Number,
            default: 0
        },
        verifiedSonyPhoto: {
            type: Boolean,
            default: false
        },
        imageGUID: {
            type: String,
            default: null
		},
		reportItemGuid: {
			type: String,
			required: true
        },
        isLiked: {
            type: Boolean,
            default: false
        },
		isSelfProfile: {
			type: Boolean,
			required: true
        },
        showLikes: {
            type: Boolean,
            default: true
        },
		equipment: {
			type: Object,
			default: () => {}
		},
		photoWidth: {
			type: String,
			default: 'auto'
		},
		hideClose: {
        	type: Boolean,
			default: false
		},
		utmCodesUsage: {
			type: String,
			default:''
		},
	},
    computed: {
        // Direct CDN URL has no responsive variants; legacy fetch builds a srcset by width.
        imageSrcset() {
            if (this.imageURL) {
                return null;
            }
            if (!this.imageZestyGuid) {
                return null;
            }
            return this.calcRespImageURL(this.imageZestyGuid, 640) + ` 640w, `
                + this.calcRespImageURL(this.imageZestyGuid, 768) + ` 768w,`
                + this.calcRespImageURL(this.imageZestyGuid, 1024) + ` 1024w,`
                + this.calcRespImageURL(this.imageZestyGuid, 1400) + ` 1366w`;
        },
        profilePhoto: {
            get() {
                const userMediaArray = this.$store.state.Public.publicUser.profileimages;
                if (!userMediaArray) {
                    return {};
                }
                const profilePhoto = userMediaArray.filter(media => media.ppd_isprofile);
                if (profilePhoto.length !== 1) {
                    return {};
                }
                return profilePhoto[0].ppd_zestyguid;
            }
        },
        profilePhotoSrc() {
            const userMediaArray = this.$store.state.Public.publicUser.profileimages;
            if (!userMediaArray) {
                return this.imagePlaceholderURL(100);
            }
            const profilePhoto = userMediaArray.filter(media => media.ppd_isprofile);
            if (profilePhoto.length !== 1) {
                return this.imagePlaceholderURL(100);
            }
            return this.resolveMediaImageURL(profilePhoto[0].ppd_imageurl, profilePhoto[0].ppd_zestyguid, 100);
        },
		cameraLink: {
        	get() {
				const camera = this.getSonyCameraByModel(this.cameraModel);

				let cameraLink;
				if(camera && camera.productUrl) {
					cameraLink = camera.productUrl;

					if(this.utmCodesUsage && this.equipment.UTM_CODES ) {
						const utmToUse = this.equipment.UTM_CODES.find(el => el.useage === this.utmCodesUsage);
						if(utmToUse) {
							cameraLink += utmToUse.utmCode;
						}
					}
				}



				return cameraLink;
			}
		},
		lensLink: {
			get() {
				const lens = this.getSonyLensByNameOrModel(this.lensModel);

				let lensLink;
				if(lens && lens.productUrl) {
					lensLink = lens.productUrl;

					if(this.utmCodesUsage && this.equipment.UTM_CODES ) {
						const utmToUse = this.equipment.UTM_CODES.find(el => el.useage === this.utmCodesUsage);
						if(utmToUse) {
							lensLink += utmToUse.utmCode;
						}
					}
				}

				return lensLink;
			}
		},
    },
    methods: {
        splitCategoryTags(tags) {
            return tags.split(',');
        },

        openReportModal() {
            this.showReportModal = true;
		},

        getCameraNameByModel(model) {
            if (this.equipment.SONY_CAMERAS === undefined || this.equipment.CANON_CAMERAS === undefined) {
                return model;
            }
            const cameras = [...this.equipment.SONY_CAMERAS, ...this.equipment.CANON_CAMERAS];
            const camera = cameras.find(camera => camera.model.toLowerCase() === model.toLowerCase());
            return camera ? camera.name : model;
        },

        getLensNameByModel(model) {
            if (this.equipment.SONY_LENSES === undefined) {
                return model;
            }
            const lenses = this.equipment.SONY_LENSES;
            const lens = lenses.find(lens => lens.model.toLowerCase() === model.toLowerCase());
            return lens ? lens.name : model;
        },

		getSonyCameraByModel(model) {
			if (!model || this.equipment.SONY_CAMERAS === undefined) {
				return undefined;
			}

			return this.equipment.SONY_CAMERAS.find(camera => camera.model.toLowerCase() === model.toLowerCase());
		},
		getSonyLensByNameOrModel(model) {
			if (!model || this.equipment.SONY_LENSES === undefined) {
				return undefined;
			}

			return this.equipment.SONY_LENSES.find(lens => lens.model.toLowerCase() === model.toLowerCase() || lens.name.toLowerCase() === model.toLowerCase());
		},

		isExposure(exposure) {
			return !! exposure;
		},
		isAperture(aperture) {
        	return !! aperture;
		},
		isIso(iso) {
			return !! iso;
		},
		isFocalLength(focalLength) {
        	return !! focalLength;
		}
    },
};
</script>

<style lang="scss">
@import '../../assets/scss/all.scss';
.aup-base-photo-details {
    &__img-container {
        background-color: $black;
    }

    &__photo {
        aspect-ratio: 16 / 9;
        width: 100%;
        max-height: calc(98vh - 472px);
        display: flex;
        justify-content: center;
        align-items: center;
        overflow: hidden;

        @media (max-width: 992px) {
            max-height: calc(98vh - 416px);
        }

        img {
            height: 100%;
            width: auto;
            max-width: 100%;
            object-fit: contain;
        }
    }
    &__username {
        max-width: 24%;
        @media (max-width: 767px) {
            max-width: none;
        }
    }
    &__exifdata {
		padding-right: 2rem;
		@include media-breakpoint-down(md) {
            padding-right: 1rem;
        }
	}
    &__row {
		padding: 1rem 0;
        .svg-primary {
            path {
                fill: $primary;
            }
        }
    }
}
</style>
